<template>
  <div>
    <div>
      <!-- <loading
        :active.sync="ismodalLoding"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <!-- Filter Agency Modal Start -->
    <b-button
      style="font-size: 0.675rem ; margin-left:5px; margin-bottom:4px;"
      @click="FilterAgency()"
      size="sm"
      variant="warning"
      >Agent Search</b-button
    >
    <b-modal
      id="FilterAgency-modal"
      ref="FilterAgency-modal"
      title="Filter Agency"
      size="xl"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      ><div>
        <h5>Filter Agency</h5>
      </div>
      <div class="row">
        <div class="col-md-8">
          <b-form-input
            class="mb-2 w-100"
            :formatter="capitalizeAll"
            v-model="filterAgent"
            v-on:keyup="AgencyFilterFunct(true)"
            placeholder="Type to Search"
          />
        </div>
         <!--himanshu-->
        <CustommodelLoader v-if="ismodalLoding" :width="70"></CustommodelLoader>
        <div class="col-md-4">
          <b-button @click="AgencyFilterFunct(false)">Clear</b-button>
        </div>
        <div class="col-md-12">
          <table class="table mb-0 table-bordered">
            <thead>
              <tr>
                <th>SN.</th>
                <th>Category Type</th>
                <th>Agent Name</th>
                <!-- <th>Co-Loader Name</th> -->
                <th>Company Details</th>
                <th>Contact Details</th>
                <th>Country Name</th>
                <th>
                  Engagement Preference <br />
                  Status
                </th>
              </tr>
            </thead>
            <tbody v-if="allAgentColoaderData.length > 0">
              <tr
                v-for="(agent_item, agent_index) in allAgentColoaderData"
                :key="agent_index"
              >
                <td>{{ agent_index + 1 }}.</td>
                <td>{{ agent_item.categoryType }}</td>
                <td>
                  {{ agent_item.agentName != "" ? agent_item.agentName : "--" }}
                </td>
                <!-- <td>
                  {{
                    agent_item.coLoaderName != ""
                      ? agent_item.coLoaderName
                      : "--"
                  }}
                </td> -->
                <td>
                  <span>Company Name : {{ agent_item.companyName }}<br /></span>
                  <span>Address : {{ agent_item.address }}<br /></span>
                </td>
                <td>
                  <span
                    >Contact No. : {{ agent_item.contactNumber }}<br
                  /></span>
                  <span>Email : {{ agent_item.emailId }}<br /></span>
                </td>
                <td>
                  <span>{{ agent_item.countryName }}<br /></span>
                </td>
                <td>
                  <span>{{ agent_item.engagementPreference }}<br /></span>
                  <b-badge>{{
                    agent_item.isACActive == 1 ? "Active" : "In-Active"
                  }}</b-badge>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="7"><center>Data Not Found</center></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <b-button
        @click="hideFilterAgency"
        variant="danger"
        class="pull-right mt-2"
      >
        Close</b-button
      >
    </b-modal>
    <!-- Filter Agency Modal End -->
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustommodelLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../helper/collection";

export default {
  props: ["allModuleIdProp", "JOBSERIES"],
  beforeMount() {},

  data() {
    return {
      allAgentColoaderData: [],
      filterAgent: "",
      ismodalLoding: false,
    };
  },
  //this.$route.params.moduleId?this.$route.params.moduleId:
  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustommodelLoader,
    DatePicker,
    ModelListSelect,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    FilterAgency() {
      this.ismodalLoding = false;
      this.$refs["FilterAgency-modal"].show();
    },
    hideFilterAgency() {
      this.ismodalLoding = false;
      this.$refs["FilterAgency-modal"].hide();
    },
    AgencyFilterFunct(status) {
      this.allAgentColoaderData = [];
      if (status == true) {
         this.ismodalLoding = true; // Start loader when filtering
        this.getAgencyFilterData(status);
        if (this.filterAgent.length === 0) {
           this.ismodalLoding = false;
        }
      } else {
        this.filterAgent = "";
        this.allAgentColoaderData = [];
         this.ismodalLoding = false; // Stop loader when clearing the filter
      }
    },
    getAgencyFilterData(status) {
      let type_Size = {
        categoryType: "categoryType",
        searchVal: this.filterAgent,
        searchFlag: status,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/filterAgentColoader.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.ismodalLoding = false;
            if (data.agentCoLoaderTable.length > 0) {
              this.allAgentColoaderData = data.agentCoLoaderTable;
              this.ismodalLoding = false;
            }
            //this.JqueryFun();
          }
        })
        .catch((error) => { });
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// filterAgencyModal.vue?0bd76ce6